/**
 * Picks the right court name/type for the active i18n language.
 *
 * Tenants author the primary copy in `name` / `type` (typically English) and
 * the optional secondary-language copy in `name_ar` / `type_ar` (typically
 * Arabic, but the schema is locale-agnostic). Mirrors `selectPackageCopy`.
 *
 * When the active language is the primary (`en`) we always render the primary
 * columns. For any other language we try `_ar` first and fall back to the
 * primary when the tenant hasn't authored the translation.
 */
export function selectCourtLabel(
  court: {
    name: string;
    name_ar?: string | null;
    type?: string | null;
    type_ar?: string | null;
  },
  language: string,
  primaryLanguage: string = 'en',
): { name: string; type: string | null } {
  const isAlt = language !== primaryLanguage;

  const nameAlt = (court.name_ar ?? '').trim();
  const typeAlt = (court.type_ar ?? '').trim();

  return {
    name: isAlt && nameAlt.length > 0 ? nameAlt : court.name,
    type: isAlt && typeAlt.length > 0 ? typeAlt : (court.type ?? null),
  };
}
